// @ts-ignore
import smoothscroll from 'smoothscroll-polyfill';

export class ScrollTo {
  triggers: NodeListOf<HTMLElement>;

  constructor() {
    this.triggers = document.querySelectorAll('[data-scroll-to]');
    if (this.triggers.length === 0) {
      return;
    }
    smoothscroll.polyfill();
    this.init();
  }

  init() {
    this.addTriggerEvents();
  }

  addTriggerEvents() {
    this.triggers.forEach((trigger) => {
      let key: string = trigger.dataset.scrollTo;
      let target: HTMLElement = document.querySelector('[data-scroll-to-target="' + key + '"]');
      if (key === '_top' || target !== null) {
        trigger.addEventListener('click', (e) => {
          let top: number = key === '_top' ? 0 : target.offsetTop;
          if (target && target.dataset.scrollToOffset) {
            top = top - (+target.dataset.scrollToOffset);
          }
          e.preventDefault();
          window.scrollTo({
            top: top,
            behavior: "smooth"
          });
        });
      }
    });
  }

}
document.addEventListener("DOMContentLoaded", function() {
  new ScrollTo();
});
